import { supabase } from "@/lib/supabase/client";

export type LpType =
  | "pension"
  | "sovereign"
  | "endowment"
  | "foundation"
  | "insurance"
  | "fof"
  | "family_office"
  | "hnw"
  | "corporate"
  | "other";

export interface Lp {
  id: string;
  tenant_id: string;
  legal_name: string;
  short_name: string | null;
  lp_type: LpType | null;
  domicile: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateLpInput {
  tenant_id: string;
  legal_name: string;
  short_name?: string | null;
  lp_type?: LpType | null;
  domicile?: string | null;
}

export async function listLps(tenantId: string): Promise<Lp[]> {
  const { data, error } = await supabase
    .from("lps")
    .select("id, tenant_id, legal_name, short_name, lp_type, domicile, created_at, updated_at")
    .eq("tenant_id", tenantId)
    .order("legal_name", { ascending: true });
  if (error) throw new Error(`listLps: ${error.message}`);
  return data ?? [];
}

export async function createLp(input: CreateLpInput): Promise<Lp> {
  const { data, error } = await supabase
    .from("lps")
    .insert(input)
    .select("id, tenant_id, legal_name, short_name, lp_type, domicile, created_at, updated_at")
    .single();
  if (error) throw new Error(`createLp: ${error.message}`);
  return data;
}

export interface UpdateLpInput {
  legal_name?: string;
  short_name?: string | null;
  lp_type?: LpType | null;
  domicile?: string | null;
}

export async function getLp(id: string): Promise<Lp> {
  const { data, error } = await supabase
    .from("lps")
    .select("id, tenant_id, legal_name, short_name, lp_type, domicile, created_at, updated_at")
    .eq("id", id)
    .single();
  if (error) throw new Error(`getLp: ${error.message}`);
  return data;
}

export async function updateLp(id: string, input: UpdateLpInput): Promise<Lp> {
  const { data, error } = await supabase
    .from("lps")
    .update(input)
    .eq("id", id)
    .select("id, tenant_id, legal_name, short_name, lp_type, domicile, created_at, updated_at")
    .single();
  if (error) throw new Error(`updateLp: ${error.message}`);
  return data;
}

export async function deleteLp(id: string): Promise<void> {
  const { error } = await supabase.from("lps").delete().eq("id", id);
  if (error) throw new Error(`deleteLp: ${error.message}`);
}
